import { axiosWithAuth, convertNumbersToString } from "helpers";

export const merchantResultsTabService = {
	getFinancials,
	getBankBalances,
};

const API_URL = process.env.REACT_APP_API_URL;

function getFinancials(merchantId) {
	const options = {
		method: "GET",
		params: {
			merchantId,
		},
		transformResponse: [convertNumbersToString],
		url: `${API_URL}/api/merchants/${merchantId}/financials`,
	};

	return axiosWithAuth(options);
}

function getBankBalances(merchantId) {
	const options = {
		method: "GET",
		params: {
			merchantId,
		},
		transformResponse: [convertNumbersToString],
		url: `${API_URL}/api/merchants/${merchantId}/bank-balances`,
	};

	return axiosWithAuth(options);
}
